import { AxiosPDFReport, getRequest, postRequest } from '../../Axios';
import { roundNumber } from '../../../../util/DaFrameword';

export const RESET_ADVANCE_APPLICATION = 'RESET_CXC_ADVANCE_APPLICATION';
export const UPDATE_ADVANCE_APPLICATION = 'UPDATE_CXC_ADVANCE_APPLICATION';

export const ResetAdvanceApplication = (sessionId, preserveRates = false, previousSessionId) => ({
  type: RESET_ADVANCE_APPLICATION, sessionId, preserveRates, previousSessionId
});
export const UpdateAdvanceApplication = (sessionId, payload) => ({
  type: UPDATE_ADVANCE_APPLICATION, sessionId, payload
});

export const GetAvailable = params => dispatch => dispatch(getRequest('/CXCAdvanceApplication/Available', params))
  .then(({ payload: { data } }) => data);
export const GetInvoices = params => dispatch => dispatch(getRequest('/CXCAdvanceApplication/Invoices', params))
  .then(({ payload: { data } }) => data);
export const GetHistory = params => dispatch => dispatch(getRequest('/CXCAdvanceApplication/History', params))
  .then(({ payload: { data } }) => data);
export const GetCurrencyRates = () => dispatch => dispatch(getRequest('/Currency/GetCurrencyWithTax', {}))
  .then(({ payload: { data } }) => Object.fromEntries((data || [])
    .map(currency => [currency.id, roundNumber(Number(currency.currencyValuation || 1), 2)])));
export const ApplyApplication = params => dispatch => dispatch(postRequest('/CXCAdvanceApplication/Apply', {}, params))
  .then(({ payload: { data } }) => data);
export const ReverseApplication = params => dispatch => dispatch(postRequest('/CXCAdvanceApplication/Reverse', {}, params))
  .then(({ payload: { data } }) => data);
export const CreatePdf = (params, dispatch) => AxiosPDFReport('CXCAdvanceApplication/Pdf', params, dispatch);
